<script lang="ts">
  import { onMount } from 'svelte';
  import { X } from 'lucide-svelte';

  type ToastType = 'success' | 'error' | 'warning' | 'info';

  type ToastItem = {
    id: number;
    message: string;
    type: ToastType;
    autoDismiss?: boolean;
    duration?: number;
  };

  let {
    toast,
    removeToast
  }: {
    toast: ToastItem;
    removeToast: (id: number) => void;
  } = $props();

  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  let mounted = false;

  onMount(() => {
    mounted = true;
    if (toast.autoDismiss !== false) {
      timeoutId = setTimeout(() => {
        removeToast(toast.id);
      }, toast.duration || 5000);
    }
  });

  function handleClose() {
    if (timeoutId) clearTimeout(timeoutId);
    removeToast(toast.id);
  }

  const typeClasses: Record<ToastType, string> = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-500 text-black',
    info: 'bg-blue-500 text-white'
  };

  const icon: Record<ToastType, string> = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  };
</script>

<div
  class="flex items-center justify-between p-4 rounded-lg shadow-lg {typeClasses[toast.type] ||
    typeClasses.info} transition-opacity duration-[var(--duration-quick)] ease-[var(--ease-out)] {mounted
    ? 'opacity-100 translate-y-0'
    : 'opacity-0 translate-y-2'}"
  role="alert"
  aria-live="assertive"
>
  <div class="flex items-center">
    <span class="mr-2 text-lg">{icon[toast.type]}</span>
    <span>{toast.message}</span>
  </div>
  <button
    onclick={handleClose}
    class="ml-4 p-1 rounded-full hover:bg-black hover:bg-opacity-20 transition-colors"
    aria-label="Close notification"
  >
    <X size={16} />
  </button>
</div>

<style>
  /* Additional styles if needed */
</style>
